import { Classification } from '.'
/**
 * 模板多维分类：枚举与 KV 选项
 * 用途：前端选择（展示/表单）与后端存储（枚举值数组）
 * 约定：key 为枚举值（数字编码），value 为中文名称
 */
// 模板类型枚举
export enum TemplateType {
  VerticalPoster = 1, // 竖版海报
  HorizontalPoster = 2, // 横版海报
  ProductMainImage = 3, // 商品主图
  XiaohongshuCover = 4, // 小红书封面
  LiveBackground = 5, // 直播背景
  LiveSticker = 6, // 直播贴片
  XiaohongshuInnerPage = 7, // 小红书内页
  ProductDetailPage = 8, // 商品详情页
  ProductDetailList = 9, // 商品详情列表
  StoreSignboard = 10, // 店铺招牌
  PLOGImage = 11, // plog图片
  CrossBorderMainImage = 12, // 跨境电商主图
  EcommerceMainImageWatermark = 13, // 电商主图水印
  EcommerceMainImageBorder = 14, // 电商主图边框
  CrossBorderLabel = 15, // 跨境电商标签
}

export enum TemplateRegion {
  CN = 'cn',
  Overseas = 'overseas',
  Common = 'common',
}

export type TemplateTypeItem = {
  key: TemplateType;
  value: string;
  isDraft: boolean;
  i18nKey: string;
  region: TemplateRegion;
};

// 电商节庆枚举
export enum EcommerceFestival {
  Double11Sale = 1, // 双11大促
  WarmSeason = 2, // 保暖季
  NationalDaySale = 3, // 国庆大促
  MidAutumnSale = 4, // 中秋大促
  Six18Sale = 5, // 618大促
  WinterSale = 6, // 冬季促销
  DragonBoatSale = 7, // 端午节大促
  Confession520 = 8, // 520告白季
  MothersDaySale = 9, // 母亲节大促
  MayDaySale = 10, // 五一大促
  SummerNewArrivals = 11, // 夏上新
  SpringNewArrivals = 12, // 春上新
  CrazySummerSeason = 13, // 狂暑季
  Double12Sale = 14, // 双12大促
  BlackFriday = 15, // 黑色星期五
  CyberMonday = 16, // 网络星期一
  ChristmasSale = 17, // 圣诞大促
  HalloweenSale = 18, // 万圣节大促
  ThanksgivingSale = 19, // 感恩节大促
  BackToSchool = 20, // 返校季
  SuperSaturday = 21, // 超级星期六
}

// 节日主题枚举
export enum HolidayTheme {
  LaborDay = 1, // 劳动节
  SolarTerms24 = 2, // 二十四节气
  AprilFools = 3, // 愚人节
  Qingming = 4, // 清明节
  YouthDay = 5, // 青年节
  MothersDay = 6, // 母亲节
  DragonBoatFestival = 7, // 端午节
  LabaFestival = 8, // 腊八节
  WinterVacation = 9, // 寒假
  NewYearsEve = 10, // 除夕
  SpringFestival = 11, // 春节
  AuspiciousStartWork = 12, // 开工大吉
  ValentinesDay = 13, // 情人节
  SchoolSeasonEnrollment = 14, // 开学纳新
  WomenDay = 15, // 妇女节
  NewYearsDay = 16, // 元旦
  StPatricksDay = 17, // 圣帕特里克节
  Easter = 18, // 复活节
  FathersDay = 19, // 父亲节
  IndependenceDay = 20, // 独立日
}

// 行业分类枚举
export enum IndustryCategory {
  General = 1, // 通用
  EcommerceStore = 2, // 电商门店
  FoodAndBeverage = 3, // 餐饮美食
  BeautyPersonalCare = 4, // 美妆个护
  ClothingShoesBags = 5, // 服饰鞋包
  DigitalLife = 6, // 数码家电
  TravelTourism = 7, // 旅游出行
  HomeGeneral = 8, // 家居百货
  MotherBabyEducation = 9, // 母婴教育
  JewelryAccessories = 10, // 珠宝饰品
  PetServices = 11, // 宠物服务
  AutoRepair = 12, // 汽车维修
  SportsOutdoors = 13, // 运动户外
  ToysHobbies = 14, // 玩具爱好
}

// 场景用途枚举
export enum ScenarioUsage {
  MarketingPromotion = 1, // 营销促销
  CrossBorderEcommerce = 2, // 跨境电商
  HolidayMoments = 3, // 节日节点
  JobRecruitment = 4, // 求职招聘
  NoticeAnnouncement = 5, // 通知公告
  OfficialMaterials = 6, // 企宣物料
  Coupon = 7, // 优惠券
  PopularScienceTribute = 8, // 科普致敬
  Invitation = 9, // 邀请函
  DailySign = 10, // 每日一签
  CorporateAdministration = 11, // 企业行政
  CampusLife = 12, // 校园生活
}

// 模板类型 KV 选项
export const TemplateTypeKV: TemplateTypeItem[] = [
  { key: TemplateType.VerticalPoster, value: '竖版海报', isDraft: true, i18nKey: 'shared.templateType.vertical_poster', region: TemplateRegion.Common },
  { key: TemplateType.HorizontalPoster, value: '横版海报', isDraft: true, i18nKey: 'shared.templateType.horizontal_poster', region: TemplateRegion.Common },
  { key: TemplateType.ProductMainImage, value: '商品主图', isDraft: false, i18nKey: 'shared.templateType.product_main_image', region: TemplateRegion.Common },
  { key: TemplateType.XiaohongshuCover, value: '小红书封面', isDraft: true, i18nKey: 'shared.templateType.xiaohongshu_cover', region: TemplateRegion.CN },
  { key: TemplateType.LiveBackground, value: '直播背景', isDraft: false, i18nKey: 'shared.templateType.live_background', region: TemplateRegion.CN },
  { key: TemplateType.LiveSticker, value: '直播贴片', isDraft: true, i18nKey: 'shared.templateType.live_sticker', region: TemplateRegion.CN },
  { key: TemplateType.XiaohongshuInnerPage, value: '小红书内页', isDraft: true, i18nKey: 'shared.templateType.xiaohongshu_inner_page', region: TemplateRegion.CN },
  { key: TemplateType.ProductDetailPage, value: '商品详情页', isDraft: true, i18nKey: 'shared.templateType.product_detail_page', region: TemplateRegion.Common },
  { key: TemplateType.ProductDetailList, value: '商品详情列表', isDraft: true, i18nKey: 'shared.templateType.product_detail_list', region: TemplateRegion.Common },
  { key: TemplateType.StoreSignboard, value: '店铺招牌', isDraft: true, i18nKey: 'shared.templateType.store_signboard', region: TemplateRegion.CN },
  { key: TemplateType.PLOGImage, value: 'plog图片', isDraft: true, i18nKey: 'shared.templateType.plog_image', region: TemplateRegion.CN },
  { key: TemplateType.CrossBorderMainImage, value: '跨境电商主图', isDraft: false, i18nKey: 'shared.templateType.cross_border_main_image', region: TemplateRegion.Overseas },
  { key: TemplateType.EcommerceMainImageWatermark, value: '电商主图水印', isDraft: false, i18nKey: 'shared.templateType.ecommerce_main_image_watermark', region: TemplateRegion.Overseas },
  { key: TemplateType.EcommerceMainImageBorder, value: '电商主图边框', isDraft: false, i18nKey: 'shared.templateType.ecommerce_main_image_border', region: TemplateRegion.Overseas },
  { key: TemplateType.CrossBorderLabel, value: '跨境电商标签', isDraft: false, i18nKey: 'shared.templateType.cross_border_label', region: TemplateRegion.Common },
];

export const OverseasTemplateTypeKV = TemplateTypeKV.filter(
  item => item.region === TemplateRegion.Overseas || item.region === TemplateRegion.Common
);

export const OverseasTemplateTypeList = OverseasTemplateTypeKV.map(item => item.key);

// 标签类

export const LabelKV: { key: Classification; value: string; isDraft: boolean; i18nKey: string; region: TemplateRegion }[] = [
  { value: 'TEMU标签', key: Classification.temu_label, isDraft: false, i18nKey: 'shared.label.temu_label', region: TemplateRegion.Common },
  { value: 'SHEIN标签', key: Classification.shein_label, isDraft: false, i18nKey: 'shared.label.shein_label', region: TemplateRegion.Common },
  { value: 'TIKTOK标签', key: Classification.tiktok_label, isDraft: false, i18nKey: 'shared.label.tiktok_label', region: TemplateRegion.Common },
  { value: 'ALIEXPRESS标签', key: Classification.aliExpress_label, isDraft: false, i18nKey: 'shared.label.aliexpress_label', region: TemplateRegion.Common },
  { value: 'AMAZON标签', key: Classification.amazon_label, isDraft: false, i18nKey: 'shared.label.amazon_label', region: TemplateRegion.Common },
  { value: '其它标签', key: Classification.other, isDraft: false, i18nKey: 'shared.label.other', region: TemplateRegion.CN },
]

// 电商节庆 KV 选项
export const EcommerceFestivalKV: { key: EcommerceFestival; value: string; isDraft: boolean; i18nKey: string; region: TemplateRegion }[] = [
  { key: EcommerceFestival.Double11Sale, value: '双11大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.double_11_sale', region: TemplateRegion.CN },
  { key: EcommerceFestival.Double12Sale, value: '双12大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.double_12_sale', region: TemplateRegion.CN },
  { key: EcommerceFestival.NationalDaySale, value: '国庆大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.national_day_sale', region: TemplateRegion.CN },
  { key: EcommerceFestival.MidAutumnSale, value: '中秋大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.mid_autumn_sale', region: TemplateRegion.CN },
  { key: EcommerceFestival.Six18Sale, value: '618大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.six_18_sale', region: TemplateRegion.CN },
  { key: EcommerceFestival.DragonBoatSale, value: '端午节大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.dragon_boat_sale', region: TemplateRegion.CN },
  { key: EcommerceFestival.Confession520, value: '520告白季', isDraft: false, i18nKey: 'shared.ecommerceFestival.confession_520', region: TemplateRegion.CN },
  { key: EcommerceFestival.MothersDaySale, value: '母亲节大促', isDraft: true, i18nKey: 'shared.ecommerceFestival.mothers_day_sale', region: TemplateRegion.Common },
  { key: EcommerceFestival.MayDaySale, value: '五一大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.may_day_sale', region: TemplateRegion.CN },
  { key: EcommerceFestival.CrazySummerSeason, value: '狂暑季', isDraft: true, i18nKey: 'shared.ecommerceFestival.crazy_summer_season', region: TemplateRegion.CN },
  { key: EcommerceFestival.BlackFriday, value: '黑色星期五', isDraft: false, i18nKey: 'shared.ecommerceFestival.black_friday', region: TemplateRegion.Overseas },
  { key: EcommerceFestival.CyberMonday, value: '网络星期一', isDraft: false, i18nKey: 'shared.ecommerceFestival.cyber_monday', region: TemplateRegion.Overseas },
  { key: EcommerceFestival.ChristmasSale, value: '圣诞大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.christmas_sale', region: TemplateRegion.Overseas },
  { key: EcommerceFestival.HalloweenSale, value: '万圣节大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.halloween_sale', region: TemplateRegion.Overseas },
  { key: EcommerceFestival.ThanksgivingSale, value: '感恩节大促', isDraft: false, i18nKey: 'shared.ecommerceFestival.thanksgiving_sale', region: TemplateRegion.Overseas },
  { key: EcommerceFestival.BackToSchool, value: '返校季', isDraft: false, i18nKey: 'shared.ecommerceFestival.back_to_school', region: TemplateRegion.Overseas },
  { key: EcommerceFestival.SuperSaturday, value: '超级星期六', isDraft: false, i18nKey: 'shared.ecommerceFestival.super_saturday', region: TemplateRegion.Overseas },
  { key: EcommerceFestival.WarmSeason, value: '保暖季', isDraft: false, i18nKey: 'shared.ecommerceFestival.warm_season', region: TemplateRegion.Common },
  { key: EcommerceFestival.WinterSale, value: '冬季促销', isDraft: false, i18nKey: 'shared.ecommerceFestival.winter_sale', region: TemplateRegion.Common },

  { key: EcommerceFestival.SummerNewArrivals, value: '夏上新', isDraft: true, i18nKey: 'shared.ecommerceFestival.summer_new_arrivals', region: TemplateRegion.Common },
  { key: EcommerceFestival.SpringNewArrivals, value: '春上新', isDraft: true, i18nKey: 'shared.ecommerceFestival.spring_new_arrivals', region: TemplateRegion.Common },
];

// 节日主题 KV 选项
export const HolidayThemeKV: { key: HolidayTheme; value: string; isDraft: boolean; i18nKey: string; region: TemplateRegion }[] = [
  { key: HolidayTheme.LaborDay, value: '劳动节', isDraft: false, i18nKey: 'shared.holidayTheme.labor_day', region: TemplateRegion.Common },
  { key: HolidayTheme.SolarTerms24, value: '二十四节气', isDraft: true, i18nKey: 'shared.holidayTheme.solar_terms_24', region: TemplateRegion.CN },
  { key: HolidayTheme.AprilFools, value: '愚人节', isDraft: false, i18nKey: 'shared.holidayTheme.april_fools', region: TemplateRegion.Common },
  { key: HolidayTheme.Qingming, value: '清明节', isDraft: false, i18nKey: 'shared.holidayTheme.qingming', region: TemplateRegion.CN },
  { key: HolidayTheme.YouthDay, value: '青年节', isDraft: true, i18nKey: 'shared.holidayTheme.youth_day', region: TemplateRegion.CN },
  { key: HolidayTheme.MothersDay, value: '母亲节', isDraft: false, i18nKey: 'shared.holidayTheme.mothers_day', region: TemplateRegion.Common },
  { key: HolidayTheme.WomenDay, value: '38女神节', isDraft: false, i18nKey: 'shared.holidayTheme.women_day', region: TemplateRegion.Common },
  { key: HolidayTheme.DragonBoatFestival, value: '端午节', isDraft: false, i18nKey: 'shared.holidayTheme.dragon_boat_festival', region: TemplateRegion.CN },
  { key: HolidayTheme.LabaFestival, value: '腊八节', isDraft: false, i18nKey: 'shared.holidayTheme.laba_festival', region: TemplateRegion.CN },
  { key: HolidayTheme.WinterVacation, value: '寒假', isDraft: false, i18nKey: 'shared.holidayTheme.winter_vacation', region: TemplateRegion.CN },
  { key: HolidayTheme.NewYearsEve, value: '除夕', isDraft: false, i18nKey: 'shared.holidayTheme.new_years_eve', region: TemplateRegion.CN },
  { key: HolidayTheme.SpringFestival, value: '春节', isDraft: false, i18nKey: 'shared.holidayTheme.spring_festival', region: TemplateRegion.CN },
  { key: HolidayTheme.AuspiciousStartWork, value: '开工大吉', isDraft: false, i18nKey: 'shared.holidayTheme.auspicious_start_work', region: TemplateRegion.CN },
  { key: HolidayTheme.ValentinesDay, value: '情人节', isDraft: true, i18nKey: 'shared.holidayTheme.valentines_day', region: TemplateRegion.Common },
  { key: HolidayTheme.SchoolSeasonEnrollment, value: '开学纳新', isDraft: true, i18nKey: 'shared.holidayTheme.school_season_enrollment', region: TemplateRegion.Common },
  { key: HolidayTheme.NewYearsDay, value: '元旦', isDraft: false, i18nKey: 'shared.holidayTheme.new_years_day', region: TemplateRegion.Common },
  { key: HolidayTheme.StPatricksDay, value: '圣帕特里克节', isDraft: false, i18nKey: 'shared.holidayTheme.st_patricks_day', region: TemplateRegion.Overseas },
  { key: HolidayTheme.Easter, value: '复活节', isDraft: false, i18nKey: 'shared.holidayTheme.easter', region: TemplateRegion.Overseas },
  { key: HolidayTheme.FathersDay, value: '父亲节', isDraft: false, i18nKey: 'shared.holidayTheme.fathers_day', region: TemplateRegion.Common },
  { key: HolidayTheme.IndependenceDay, value: '独立日', isDraft: false, i18nKey: 'shared.holidayTheme.independence_day', region: TemplateRegion.Overseas },
];

// 行业分类 KV 选项
export const IndustryCategoryKV: { key: IndustryCategory; value: string; isDraft: boolean; i18nKey: string; region: TemplateRegion }[] = [
  { key: IndustryCategory.General, value: '通用', isDraft: false, i18nKey: 'shared.industryCategory.general', region: TemplateRegion.Common },
  { key: IndustryCategory.EcommerceStore, value: '电商门店', isDraft: false, i18nKey: 'shared.industryCategory.ecommerce_store', region: TemplateRegion.CN },
  { key: IndustryCategory.FoodAndBeverage, value: '餐饮美食', isDraft: false, i18nKey: 'shared.industryCategory.food_and_beverage', region: TemplateRegion.CN },
  { key: IndustryCategory.BeautyPersonalCare, value: '美妆个护', isDraft: false, i18nKey: 'shared.industryCategory.beauty_personal_care', region: TemplateRegion.Common },
  { key: IndustryCategory.ClothingShoesBags, value: '服饰鞋包', isDraft: false, i18nKey: 'shared.industryCategory.clothing_shoes_bags', region: TemplateRegion.Common },
  { key: IndustryCategory.DigitalLife, value: '数码家电', isDraft: false, i18nKey: 'shared.industryCategory.digital_life', region: TemplateRegion.Common },
  { key: IndustryCategory.TravelTourism, value: '旅游出行', isDraft: false, i18nKey: 'shared.industryCategory.travel_tourism', region: TemplateRegion.CN },
  { key: IndustryCategory.HomeGeneral, value: '家居百货', isDraft: false, i18nKey: 'shared.industryCategory.home_general', region: TemplateRegion.Common },
  { key: IndustryCategory.MotherBabyEducation, value: '母婴教育', isDraft: false, i18nKey: 'shared.industryCategory.mother_baby_education', region: TemplateRegion.CN },
  { key: IndustryCategory.JewelryAccessories, value: '珠宝饰品', isDraft: false, i18nKey: 'shared.industryCategory.jewelry_accessories', region: TemplateRegion.Common },
  { key: IndustryCategory.PetServices, value: '宠物服务', isDraft: false, i18nKey: 'shared.industryCategory.pet_services', region: TemplateRegion.Common },
  { key: IndustryCategory.AutoRepair, value: '汽车维修', isDraft: false, i18nKey: 'shared.industryCategory.auto_repair', region: TemplateRegion.CN },
  { key: IndustryCategory.SportsOutdoors, value: '运动户外', isDraft: false, i18nKey: 'shared.industryCategory.sports_outdoors', region: TemplateRegion.Overseas },
  { key: IndustryCategory.ToysHobbies, value: '玩具爱好', isDraft: false, i18nKey: 'shared.industryCategory.toys_hobbies', region: TemplateRegion.Overseas },
];

// 场景用途 KV 选项
export const ScenarioUsageKV: { key: ScenarioUsage; value: string; isDraft: boolean }[] = [
  { key: ScenarioUsage.MarketingPromotion, value: '营销促销', isDraft: true },
  { key: ScenarioUsage.CrossBorderEcommerce, value: '跨境电商', isDraft: true },
  { key: ScenarioUsage.HolidayMoments, value: '节日节点', isDraft: true },
  { key: ScenarioUsage.JobRecruitment, value: '求职招聘', isDraft: true },
  { key: ScenarioUsage.NoticeAnnouncement, value: '通知公告', isDraft: true },
  { key: ScenarioUsage.OfficialMaterials, value: '企宣物料', isDraft: true },
  { key: ScenarioUsage.Coupon, value: '优惠券', isDraft: true },
  { key: ScenarioUsage.PopularScienceTribute, value: '科普致敬', isDraft: true },
  { key: ScenarioUsage.Invitation, value: '邀请函', isDraft: true },
  { key: ScenarioUsage.DailySign, value: '每日一签', isDraft: true },
  { key: ScenarioUsage.CorporateAdministration, value: '企业行政', isDraft: true },
  { key: ScenarioUsage.CampusLife, value: '校园生活', isDraft: true },
];
